import Vue from 'vue'
import VueI18n from 'vue-i18n'
import axios from 'axios'
import store from '@/store'
import get from 'lodash/get'

const defaultLang = 'en';
const getI18n = function () {
  Vue.use(VueI18n)
  let locale = store.getters.getLanguage
  if (!locale) {
    const params = new URLSearchParams(window.location.search)
    locale = params.get('lang') || navigator.language
    if (locale && locale.length > 1) {
      locale = locale.split('-')[0]
      store.commit('setLanguage', locale)
    }
  }
  document.querySelector('html').lang = locale
  return new VueI18n({
    messages: {},
    locale: locale, // set locale
    silentTranslationWarn: true,
    fallbackLocale: defaultLang // default language if not found
  })
}

const setLanguageAsync = function (app, lang) {
  const navigatorDefaultLanguage = navigator.language.split('-')[0]
  let apiUrl = app.$store.getters.getConfigUrls['apiUrl']
  const langList = get(
      app.$store.getters, 'getLangSwitcher.languages.items', [{ lang: navigatorDefaultLanguage }]
  ).map(x => { return x.lang })

  if (langList && !langList.includes(lang)) {
    // KE-4240 seteo de idioma por defecto si no existe el idioma del browser
    const avaliableLang = app.$store.getters.getLangSwitcher.languages.items
    const existsLanguaje = avaliableLang > 0 && avaliableLang.some((i) => i.lang === lang)
    if (!existsLanguaje && avaliableLang.length > 0) {
      lang = avaliableLang[0].lang
    } else {
      lang = defaultLang
    }
    app.$store.commit('setLanguage', lang)
    app.$i18n.locale = lang
  }

  axios.defaults.headers.common['Lang'] = lang

  if (!app.$store.getters.getAvailableLanguages.includes(lang)) {
    return axios.get(`${apiUrl}translations/`)
        .then(response => {
          if (typeof response.data != "object") {
            throw 'error fetching translations, setting english default messages'
          }
          let messages = response.data.response
          app.$i18n.setLocaleMessage(lang, messages)
          app.$store.commit('addAvailableLanguages', lang)
        })
        .catch(() => {
          let defaultMessages = require('../locales/en.json')
          app.$i18n.setLocaleMessage(defaultLang, defaultMessages)
          app.$store.commit('setLanguage', defaultLang)
          app.$i18n.locale = defaultLang
          console.log('error in translations')
          // app.$router.push('internal-error')
        })
        .finally(() => { return Promise.resolve() })
  }
}

export { getI18n, setLanguageAsync }
